module.exports = __webpack_public_path__ + "img/SS.782de8eb.svg";